<template>
  <div>
    <template class="mt-1" v-if="canVerb(resource, 'index')">
      <actions-toolbar>
        <template #filters>
          <div class="status-filter">
            <div class="pill-wrapper my-3">
              <span
                class="pill"
                v-for="(value, name, index) in visibleFilters"
                :key="index"
                data-color="white"
              >
                <span v-b-toggle.sidebar-1 :data-filter="name"
                  ><strong>{{ sidebarFilterName(name, context) }}</strong
                  >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                >
                <span
                  :class="{ 'hidden-filter-x': isFilterRequired(name) }"
                  tabindex="0"
                >
                  <span
                    @click="resetSingleSidebarFilter(name)"
                    title="Rimuovi filtro"
                    >×</span
                  >
                </span>
              </span>
              <template v-if="countVisibleFilters > 0">
                <span
                  class="pill"
                  data-color="alert"
                  @click="resetAllFilters()"
                  title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                >
                  <span
                    ><strong>Reset ({{ countVisibleFilters }})</strong></span
                  >
                  <span><span>×</span></span>
                </span>
              </template>
            </div>
          </div>
        </template>
        <b-button-group
          v-b-toggle.sidebar-1
          :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
            countVisibleFilters ? ' active' : ''
          }`"
          :title="getDefaultFilterMessage()"
        >
          <base-icon name="filters" width="23" height="23" />
          <span style="font-size: 14px; font-weight: 500">{{
            computedFilterTitle
          }}</span>
        </b-button-group>
        <export-options
          :exportUrl="exportUrl"
          :repository="repository"
          :resource="resource"
          :tableRef="$refs[tableRef]"
          :filter="filter"
          :options="[
            {
              code: 'LISTACC',
              label: null,
              formats: ['csv', 'pdf'],
            },
          ]"
        ></export-options>
        <b-button
          class="btn-create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="onAddBookEntry('brokers')"
          title="Crea un nuovo acconto Produttore"
          v-if="
            canVerb(resource, 'store') &&
            !['P', 'B'].includes(
              $store.state.auth.settings.attribute_SHOWACC_value
            )
          "
        >
          <base-icon name="circled_plus" width="22" height="22" />
          Crea Acconto Produttore
        </b-button>
        <b-button
          class="btn-create btn--smaller"
          type="button"
          variant="primary"
          size="sm"
          @click="onAddBookEntry('registries')"
          title="Crea un nuovo acconto Cliente"
          v-if="
            canVerb(resource, 'store') &&
            !['C', 'B'].includes(
              $store.state.auth.settings.attribute_SHOWACC_value
            )
          "
        >
          <base-icon name="circled_plus" width="22" height="22" />
          Crea Acconto Cliente
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          class="btn--smaller btn--transparent"
          title="Chiusura massiva selezionati"
          @click="openMassReducedModal()"
        >
          <base-icon name="circled_plus" width="22" height="22" />
          Chiusura massiva selezionati
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          class="btn--smaller btn--transparent"
          title="Chiusura massiva di tutti gli acconti"
          :disabled="!depositedCount"
          @click="openMassReduceAll()"
        >
          <base-icon name="circled_plus" width="22" height="22" />
          Chiusura massiva di tutti gli acconti
        </b-button>
      </actions-toolbar>
      <div class="table-container">
        <b-sidebar
          id="sidebar-1"
          :title="computedFilterTitle"
          :backdrop="true"
          width="50dvw"
          shadow
          right
          :visible="open_filter"
          :data-open="open_filter"
          @change="onSidebarFilterChange"
        >
          <!-- <template #header="{ hide }">
            <div class="inner-header">
              <template v-if="canVerb(resource, 'store')">
                <div class="inner-header--create">
                  <strong class="mr-auto"> Crea un nuovo acconto </strong>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                      gap: 10px;
                    "
                  >
                    <b-button
                      class="btn-create btn--smaller"
                      type="button"
                      variant="primary"
                      size="sm"
                      @click="onAddBookEntry('brokers')"
                      title="Crea un nuovo acconto Produttore"
                      :disabled="!canVerb(resource, 'store')"
                    >
                      <base-icon name="circled_plus" width="16" height="16" />
                      Per Produttore
                    </b-button>
                    <b-button
                      class="btn-create btn--smaller"
                      type="button"
                      variant="primary"
                      size="sm"
                      @click="onAddBookEntry('registries')"
                      title="Crea un nuovo acconto Cliente"
                      :disabled="!canVerb(resource, 'store')"
                    >
                      <base-icon name="circled_plus" width="16" height="16" />
                      Per Cliente
                    </b-button>
                  </div>
                </div>
                <div class="inner-header--info">
                  <strong class="mr-auto">
                    {{ computedFilterTitle }}
                  </strong>
                  <button class="close text-dark" @click="hide">
                    <b-icon icon="x"></b-icon>
                  </button>
                </div>
              </template>
              <template v-else>
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </template>
            </div>
          </template> -->
          <b-form @submit.prevent="onSearch(filterName)">
            <div class="filter">
              <div class="filter-item" data-cols="3">
                <base-select
                  name="deposit"
                  label="Mostra Acconti"
                  :options="deposit"
                  v-model="filter.byDeposited"
                />
                <base-input
                  name="Contraente"
                  v-model="filter.byRegistry.title"
                  type="text"
                  label="Contraente"
                  placeholder="Inserisci un nominativo"
                />
                <base-input
                  name="number"
                  type="text"
                  label="Polizza"
                  v-model="filter.byInsurancePolicy.number"
                  placeholder="Inserisci un numero polizza"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <div>
                  <base-select
                    name="salesman_id"
                    label="Produttori"
                    :multiple="true"
                    :options="salesmen_select"
                    v-model="filter.byBroker.id"
                    :closeOnSelect="false"
                    :taggable="salesmen_taggable"
                    :defaultHtmlMultipleSelect="true"
                    @changeTaggable="changeTaggable"
                  >
                    <template #advanced-actions>
                      <b-button
                        :pressed.sync="myToggle"
                        variant="light"
                        class="btn--x-smaller btn--smaller btn--transparent"
                        @click="
                          myToggle ? selectAllSalesmen() : deselectAllSalesmen()
                        "
                        >{{
                          myToggle ? "Deseleziona tutti" : "Seleziona tutti"
                        }}
                      </b-button>
                      <b-button
                        :pressed.sync="myTogglePO"
                        variant="light"
                        class="btn--smaller btn--x-smaller btn--transparent"
                        @click="
                          myTogglePO
                            ? salesmenOrderByCode()
                            : salesmenOrderByName()
                        "
                        >{{
                          myTogglePO ? "Ordine per nome" : "Ordina per codice"
                        }}
                      </b-button>
                    </template>
                  </base-select>
                </div>
                <base-select
                  name="companies"
                  label="Compagnia"
                  :options="companies"
                  v-model="filter.byInsurer.id"
                  :multiple="true"
                  :taggable="true"
                  :closeOnSelect="false"
                  :defaultHtmlMultipleSelect="true"
                />
              </div>
              <div class="filter-item">
                <base-select
                  name="code"
                  label="Modalità rec. acconti"
                  :options="treasuries"
                  v-model="filter.byReduced.treasury_deposit"
                  :multiple="true"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-input
                  name="number"
                  type="text"
                  label="Numero Polizza"
                  v-model="filter.byInsurancePolicy.number"
                  placeholder="Inserisci un numero polizza"
                />
                <base-select
                  name="book_tags"
                  label="Codice Documento"
                  v-model="filter.byBookTag.id"
                  :options="book_tags_opt"
                />
              </div>
              <div class="filter-item" data-type="registry-group">
                <div>
                  <b-button-toolbar>
                    <b-button-group>
                      <base-input
                        :class="{
                          'filter-item-inner-wrapped': true,
                        }"
                        name="Gruppo Anagrafico"
                        label="Gruppo Anagrafico"
                        v-model="form.inpt_label_group"
                        :readonly="true"
                      />
                      <b-button
                        class="btn-quick btn--light"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        title="Cerca gruppo anagrafico"
                        @click="openQuickSearchGroup"
                      >
                        <!-- <b-icon icon="search"></b-icon> -->
                        <base-icon
                          name="search"
                          width="14"
                          height="14"
                        ></base-icon>
                      </b-button>
                      <b-button
                        v-if="form.inpt_label_group"
                        class="btn--light btn--alert"
                        size="sm"
                        text="Button"
                        variant="lisaweb"
                        @click="resetGroupId"
                        title="Elimina gruppo anagrafico"
                      >
                        <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                        <base-icon
                          name="trash"
                          width="22"
                          height="22"
                        ></base-icon>
                      </b-button>
                    </b-button-group>
                  </b-button-toolbar>
                </div>
              </div>
              <quick-search-group-modal
                ref="quickSearchGroup"
                @input="handleGroupModalInput"
              ></quick-search-group-modal>
              <div class="filter-item" data-type="registry-group-info">
                <div class="details-card-wrapper" v-if="extra_group_full_info">
                  <b-card>
                    <div
                      slot="header"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <p class="mb-0 d-inline-block align-middle">
                        <strong
                          >Informazioni gruppo anagrafico selezionato</strong
                        >
                      </p>
                    </div>
                    <div
                      class="custom-grid-wrapper"
                      v-html="extra_group_full_info"
                    ></div>
                  </b-card>
                </div>
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="aperto_dal"
                  label="Periodo di registrazione acconto dal"
                  v-model="filter.byCalendar.from"
                />
                <base-datepicker
                  name="aperto_al"
                  label="Periodo di registrazione acconto al"
                  v-model="filter.byCalendar.to"
                />
              </div>
              <div class="filter-item" data-cols="2">
                <base-datepicker
                  name="incasso_successivo"
                  label="Periodo di recupero acconto dal"
                  v-model="filter.byReduced.after_recovery"
                />
                <base-datepicker
                  name="incasso_precedente"
                  label="Periodo di recupero acconto al"
                  v-model="filter.byReduced.before_recovery"
                />
              </div>
            </div>
            <div class="actions-filter-sidebar-wrapper">
              <b-button
                type="submit"
                variant="lisaweb"
                size="sm"
                v-b-toggle:sidebar-1
                >Cerca
              </b-button>
              <b-button
                class="btn--transparent btn-reset"
                type="button"
                size="sm"
                @click="onClearFilter(filterName)"
              >
                Reset
              </b-button>
            </div>
          </b-form>
        </b-sidebar>
        <book-entries-deposited
          :fields="fields"
          :repository="repository"
          :filterOn="{
            byRelations: [
              'byVariousAccounting',
              'byRegistry',
              'byBroker',
              'byTask',
              'byDocument',
              'byInsurancePolicy',
            ],
          }"
          :resource="resource"
          :filterName="filterName"
          @manualFetch="manualFetch"
          :performedSearch="computePerformedSearch"
          :filterCount="countVisibleFilters"
          :ref="tableRef"
          :onlyActions="['edit', 'destroy', 'infomodal']"
          :hasChecksButtonGroup="false"
          hasChecks
          :total_deposited="total_deposited"
          @onMassReduced="openMassReducedModal"
          descending
          @destroy="onDestroyBookEntryDeposited"
          @edit="onEdit"
          sortField="book_date"
        ></book-entries-deposited>
        <mass-reduced-modal-deposited
          @save="onMassReducedSave"
          :grandtotaldeposited="grandtotaldeposited"
          :mode="massReduceMode"
          :total="massReduceTotal"
          :total-amount="massReduceAmount"
        ></mass-reduced-modal-deposited>
      </div>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import BaseIcon from "@/components/BaseIcon";
import BookEntriesDeposited from "@/components/tables/BookEntriesDeposited";
import massReducedModalDeposited from "@/components/modals/massReducedModalDeposited";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import BaseInput from "@/components/form/BaseInput";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData /* , toRelationString */ } from "@/utils/transforms";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import FormMixin from "@/mixins/FormMixin";
import { mapGetters, mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import ExportOptions from "@/components/ExportOptions";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
import { prepareFilterQueryString } from "@/utils/forms";

export default {
  mixins: [
    CustomFiltersMixin,
    FormMixin,
    StorageGetterMixin,
    SidebarFilterMixin,
  ],
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      filterName: "filterAccountingDeposited",
      resource: "book_entries",
      context: "book_entries_deposited",
      repository: "book_entry",
      tableRef: "AccountingDepositedTableRef",
      salesmen: [],
      myTogglePO: false,
      myToggle: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      performedSearch: false,
      activeFilters: {},
      notes: [],
      documents: [],
      companies: [],
      treasuries: [],
      book_tags_opt: [],
      registry_group_data: null,
      registry_data: null,
      grandtotaldeposited: null,
      massReduceMode: "selection",
      massReduceFilter: "",
      massReduceTotal: 0,
      massReduceAmount: null,
      depositedCount: 0,
      total_deposited: {
        isLoading: true,
        total: null,
      },
      group_data: null,
      extra_group_full_info: null,
      form: {
        inpt_label_registry: "",
        inpt_label_group: "",
        quick_value: "",
      },
      fields: [
        {
          key: "check",
          label: "",
          sortable: false,
          thClass: "check",
          class: "check",
        },
        {
          key: "recovery_status",
          label: this.getDictionary("Stato"),
          sortable: false,
        },
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          sortable: true,
          sortKey: "book_date",
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "last_deposited",
          label: this.getDictionary("Ultimo Recupero"),
          sortable: true,
          sortKey: "byView.max",
        },
        {
          key: "insurer_id",
          label: this.getDictionary("insurer"),
          sortable: true,
          sortKey: "byInsurer.title",
          formatter: (value) => this.retriveInsurer(value),
        },
        {
          key: "various_accountings_insurance_ancillaries",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
          sortable: false,
          sortKey: "byInsurancePolicy.number",
        },
        {
          key: "book_tags",
          label: "Descrizione",
          sortable: false,
          // sortKey: "byInsurancePolicy.number",
          formatter: (value) => this.retriveDescription(value),
        },
        {
          key: "registry",
          label: this.getDictionary("registry", "book_entry"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
          sortable: true,
          sortKey: "byBroker.BUID",
        },
        // {
        //   key: "title",
        //   label: this.getDictionary("title", "book_entry"),
        // },
        {
          key: "positive_deposited",
          label: this.getDictionary("Importo Acconto"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "total_deposited",
          label: this.getDictionary("Residuo Da Recuperare"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "note_counter",
          label: this.getDictionary("note"),
        },
        {
          key: "document_counter",
          label: this.getDictionary("document"),
        },
      ],
      deposit: [
        { value: "yes", text: "Aperti e parzialmente aperti" },
        { value: "no", text: "Chiusi e parzialmente recuperati" },
        { value: "reduced", text: "Parzialmente aperti" },
      ],
    };
  },
  components: {
    BaseIcon,
    // ButtonGroupTable,
    BaseSelect,
    BaseDatepicker,
    BaseInput,
    BookEntriesDeposited,
    QuickSearchGroupModal,
    ExportOptions,
    massReducedModalDeposited,
  },
  methods: {
    toInfoData,
    prepareFilterQueryString,
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    retriveDescription(value) {
      console.log("value", value);
      return value?.[0]?.code && value?.[0]?.title
        ? `${value[0].code} ${value[0].title}`
        : "-";
    },
    processQueryString(query) {
      const afterDepositedMatch = query.match(
        /byReduced\[after_deposited\]=([^&]+)/,
      );
      const beforeDepositedMatch = query.match(
        /byReduced\[before_deposited\]=([^&]+)/,
      );

      // Extract the values if they exist
      const afterDepositedValue = afterDepositedMatch
        ? afterDepositedMatch[1]
        : null;
      const beforeDepositedValue = beforeDepositedMatch
        ? beforeDepositedMatch[1]
        : null;

      // If both values are present
      if (afterDepositedValue && beforeDepositedValue) {
        // Combine values into `byReduced[between_deposited]`
        const combinedValue = `byReduced[between_deposited]=${afterDepositedValue},${beforeDepositedValue}`;

        // Remove the old parameters
        query = query
          .replace(/byReduced\[after_deposited\]=[^&]+&?/, "")
          .replace(/byReduced\[before_deposited\]=[^&]+&?/, "");

        // Ensure no trailing `&` and append the new parameter
        query = query.replace(/&$/, ""); // Clean up trailing `&` if any
        query = `${query}&${combinedValue}`;
      }

      return query;
    },
    storeMassReduced(form) {
      if (this.$refs["AccountingDepositedTableRef"].selectedRows.length) {
        // Elementi selezionati
        let items = this.$refs["AccountingDepositedTableRef"].items;
        let selectedItems = items.filter(
          (item) => item.check && this.totalDeposited(item) !== 0,
        );
        if (selectedItems.every((item) => item.book_date <= form.book_date)) {
          // Payload
          let payload = {
            treasury_id: null,
            detail_date: form.book_date,
            gross: null,
            book_entry_id: null,
          };

          // Promise
          let storedeposited = [];

          const allItemPromises = Object.values(selectedItems).map((item) => {
            storedeposited = [];

            // Forma di pagamento
            payload.gross = -parseFloat(this.totalDeposited(item).toFixed(2));
            payload.book_entry_id = item.id;
            payload.treasury_id = form.treasury_id;
            let detail = this.store("entry_detail", payload);
            storedeposited.push(detail);

            // Acconto
            payload.gross = -parseFloat(this.totalDeposited(item).toFixed(2));
            payload.treasury_id = this.getTreasuries()([]).find(
              (treasury) => treasury.code === "AC",
            ).value;
            let deposited = this.store("entry_detail", payload);
            storedeposited.push(deposited);

            // Pivot
            return Promise.all(storedeposited)
              .then((response) => {
                //Store Pivot, counter
                let pivotPayload = { entry_detail: {} };
                let depositedId = response.find(
                  (entry_detail) =>
                    entry_detail.data.data.treasury.code === "AC",
                ).data.data.id;
                response
                  .filter(
                    (entry_detail) =>
                      entry_detail.data.data.treasury.code !== "AC",
                  )
                  .forEach(
                    (entry_detail) =>
                      (pivotPayload.entry_detail[entry_detail.data.data.id] =
                        {}),
                  );

                return this.storeEntryDetail(
                  depositedId,
                  "entry_detail",
                  pivotPayload,
                );
              })
              .catch((error) => {
                let errMsg = this.$getErrorMessage(error);
                this.$showSnackbar({
                  preset: "error",
                  text: `${errMsg}`,
                });
              });
          });
          Promise.all(allItemPromises)
            .then(() => {
              this.$showSnackbar({
                preset: "success",
                text: `Azione Completata: Chiusura Massiva Completata`,
              });
              this.$refs["AccountingDepositedTableRef"].fetch();
              this.$bvModal.hide(`massReducedModal`);
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        } else {
          this.$showSnackbar({
            preset: "error",
            text: "Non è possibile procedere per la presenza di sospesi con data reg. superiore alla data di chiusura",
          });
        }
      } else {
        this.$showSnackbar({
          preset: "error",
          text: "Devi selezionare almeno una riga",
        });
      }
    },
    storeEntryDetail(depositedEntryDetailId, relation, payload) {
      const Repo = RepositoryFactory.get("entry_detail");
      return Repo.pivot_store(depositedEntryDetailId, relation, payload);
    },
    openMassReducedModal() {
      this.massReduceMode = "selection";
      this.grandtotaldeposited =
        this.$refs["AccountingDepositedTableRef"].grandTotalDeposited;
      this.$bvModal.show("massReducedModal");
    },
    openMassReduceAll() {
      const table = this.$refs[this.tableRef];
      this.massReduceMode = "all";
      this.massReduceFilter = table
        ? table.buildDepositedFilterQueryString()
        : "";
      this.massReduceTotal = table ? table.totalItems : 0;
      this.massReduceAmount =
        this.total_deposited.total != null
          ? toLocaleCurrency(this.total_deposited.total)
          : null;
      this.$bvModal.show("massReducedModal");
    },
    onMassReducedSave(form) {
      if (this.massReduceMode === "all") {
        this.storeMassReduceAll(form);
      } else {
        this.storeMassReduced(form);
      }
    },
    storeMassReduceAll(form) {
      const payload = {
        treasury_id: form.treasury_id,
        detail_date: form.book_date,
        filter: this.massReduceFilter,
        type: "deposit",
      };
      this.$bvModal.hide("massReducedModal");
      this.$root.$emit("massReduceStart", {
        payload,
        total: this.massReduceTotal,
        context: {
          entity: "acconti",
          routeName: "book_entries.index2",
          reloadEvent: "reloadDeposited",
          goLabel: "Vai agli acconti",
        },
      });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveInsurer(value) {
      let insurer_text = "";
      this.companies.forEach((company) => {
        if (company.value === value) insurer_text = company.text;
      });
      return insurer_text ? insurer_text : "-";
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.total_deposited = { isLoading: false, total: null };
      this.grandtotaldeposited = null;
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    onAddBookEntry(depositType) {
      this.$router.push({
        name: `book_entries.create`,
        params: { mode: "III", source: depositType },
      });
    },
    onDestroyBookEntryDeposited(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Movimento Eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onEdit(item) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${item.id}`, item: item, mode: "III" },
      });
    },
    initFilter() {
      let init = {
        byAttribute: {},
        byView: "deposit",
        byRegistry: {
          id: null,
        },
        byBroker: {
          id: null,
        },
        byInsurer: {
          id: null,
        },
        byInsurancePolicy: {
          number: null,
        },
        byRegistryGroup: {
          code: null,
        },
        byBookTag: {
          id: null,
        },
        byDeposited: "yes",
        byCalendar: {
          from: null,
          to: null,
        },
        byReduced: {
          after_recovery: null,
          before_recovery: null,
          treasury_deposit: null,
        },
      };
      return init;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    isFilterRequired(name) {
      const defaultFilters = this.initFilter();
      if (name in defaultFilters) {
        return (
          JSON.stringify(this.visibleFilters[name]) ===
          JSON.stringify(defaultFilters[name])
        );
      }
      return false;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      // quicksearch
      criteria = {};
      ["quickSearchPolicy", "quickSearchRegistry", "quickSearchGroup"].forEach(
        (element) => {
          criteria[element] = {
            label: "",
            formLabel: "",
            data: null,
            formData: null,
          };
        },
      );
      criteria.quickSearchPolicy.label = this.form.inpt_label_policy;
      criteria.quickSearchPolicy.formLabel = "form.inpt_label_policy";
      criteria.quickSearchPolicy.data = this.insurance_policy_data;
      criteria.quickSearchPolicy.formData = "insurance_policy_data";
      criteria.quickSearchRegistry.label = this.form.inpt_label_registry;
      criteria.quickSearchRegistry.formLabel = "form.inpt_label_registry";
      criteria.quickSearchRegistry.data = this.registry_data;
      criteria.quickSearchRegistry.formData = "registry_data";
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      this.saveQuickSearchByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;

      const qs = this.prepareFilterQueryString(this.filter);
      this.total_deposited = {
        isLoading: true,
        total: null,
      };

      this.$refs[this.tableRef]
        .fetch()
        .then(() => {
          this.depositedCount = this.$refs[this.tableRef].totalItems || 0;
          this.loadDepositedTotal(qs);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    loadDepositedTotal(qs) {
      const Repo = RepositoryFactory.get("book_entry");
      const qs_processed = this.processQueryString(qs);
      this.isLoading = true;
      Repo.deposited_total(qs_processed)
        .then((response) => {
          this.total_deposited.total = response.data.deposited_total;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.total_deposited.isLoading = false;
          this.isLoading = false;
        });
    },
    onClearFilter(name) {
      this.resetRegistryId();
      this.resetGroupId();
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeQuickSearchByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.$refs[this.tableRef].sortBy = "book_date";
      this.$refs[this.tableRef].sortDesc = true;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    openQuickSearchRegistry() {
      this.filter.byRegistry.id = null;
      this.$bvModal.show("quickSearchRegistryModal");
    },
    handleRegistryModalInput(value) {
      this.filter.byRegistry.id = value.id;
      this.registry_data = value;
      this.form.inpt_label_registry = this.toInfoData(
        this.registry_data,
        "registryfullname",
      );
      this.$bvModal.hide("quickSearchRegistryModal");
    },
    resetRegistryId() {
      this.registry_data = null;
      this.form.inpt_label_registry = null;
      this.filter.byRegistry.id = null;
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    totalDeposited(item) {
      return parseFloat(
        item.entry_details
          .filter((el) => el.treasury.code == "AC")
          .reduce(function (acc, obj) {
            return acc + obj.gross;
          }, 0)
          .toFixed(2),
      );
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getBookTags: "book_tags",
      getTreasuries: "treasuries",
    }),
  },
  computed: {
    visibleFilters() {
      const others = { ...this.activeFilters };
      delete others.byView;
      return others;
    },
    countVisibleFilters() {
      return Object.keys(this.visibleFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countVisibleFilters ? ` (${this.countVisibleFilters})` : ""
      }`;
    },
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    //   // #1153 se non c'è già un filtro salvato, imposto i valori di default
    //   let found = this.loadFilter(this.filterName);
    //   if (!found) {
    //     this.$set(this, "filter", this.initFilter());
    //   } else {
    //     this.$set(this, "filter", found);
    //   }
  },
  // beforeDestroy() {
  //   this.onClearFilter(this.filterName);
  //   /* Fix navigazione all'interno del modulo CONT */
  //   const filterName = "filterRegistryGroup";
  //   this.removeFilterByName(filterName);
  //   this.removePaginationByName(filterName);
  //   this.removeSortByName(filterName);
  // },
  mounted() {
    if (this.$refs[this.tableRef]) {
      const qs = this.prepareFilterQueryString(this.filter);
      this.loadDepositedTotal(qs);
    }
    this.salesmen = this.getSalesmen();
    this.treasuries = this.getTreasuries()(["AC"]);
    this.onReloadDeposited = () => this.onSearch(this.filterName);
    this.$root.$on("reloadDeposited", this.onReloadDeposited);
  },
  beforeDestroy() {
    this.$root.$off("reloadDeposited", this.onReloadDeposited);
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("insurers")) {
      resources.push(
        this.$store
          .dispatch(`${path}insurers`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.companies = this.getInsurers();
    }
    if (!this.hasLoadedResource("book_tags")) {
      resources.push(
        this.$store
          .dispatch(`${path}book_tags`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.book_tags_opt = this.getBookTags();
    }
    if (!this.hasLoadedResource("councils"))
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {
            console.info(`background data "${path}councils" fetched correctly`);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("provinces"))
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {
            console.info(
              `background data "${path}provinces" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            console.info(
              `background data "${path}countries" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.companies = this.getInsurers();
          this.book_tags_opt = this.getBookTags();
          console.log("All promises went through correctly");
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
  },
};
</script>
<style scoped></style>
